module.exports = __webpack_public_path__ + "static/media/icon-hsg-logo.ec69b185.svg";